export default "__VITE_ASSET__qnRF8NUj__"